import { getActualGenerationPerTypeChartData } from "api/dataVisualisation/actualGenerationPerType/actualGenerationPerType";
import useRequest, { RequestStatus } from "hooks/useRequest";
import { AgptChartModel } from "models/actualGenerationModel/actualGeneration";
import DateFilterModel from "models/filterModels/dateFilterModel";
import { useCallback } from "react";

const useActualGenerationPerTypeChartData = (
  dateFilter: DateFilterModel
): {
  fetchData: () => void;
  data: AgptChartModel[] | null;
  status: RequestStatus;
} => {
  const {
    data,
    status,
    request: fetchChartData,
  } = useRequest(getActualGenerationPerTypeChartData);

  const fetchData = useCallback(() => {
    fetchChartData(dateFilter);
  }, [dateFilter, fetchChartData]);

  return {
    data: data?.data ?? null,
    status,
    fetchData,
  };
};

export default useActualGenerationPerTypeChartData;
